import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";

export class AgentLinkCtrl implements IController {

  agent: AgentModel;
  linkToAgentView: boolean;
  isShowCopyButton: boolean;
  isShowFilterByButton: boolean;
  onFilterByType: Function;

  public isShowAccountActions: boolean;
  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
  public fullName: string;

  constructor(private $filter) {
  }


  $onInit() {
    if (this.agent) {
      this.setAgentFullName();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.agent && !changes.agent.isFirstChange()) {
      this.setAgentFullName();
    }
  }

  setAgentFullName() {
    if(this.agent){
      this.fullName = this.$filter('userName')(this.agent.user);
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentItineraryLink', {
    bindings: {
      agent: '<',
      linkToAgentView: '<?',
      isShowCopyButton: '<?',
      isShowFilterByButton: '<?',
      onFilterByType: '&'
    },
    template: require('./agent-itinerary-link.html').default,
    controller: AgentLinkCtrl
  });
